//DoctorUserCard.js
import {
  Box,
  Card,
  Divider,
  Grid,
  IconButton,
  styled,
  Button,
  Dialog,
  Typography,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  TextField,
  IconButton as MuiIconButton
} from '@mui/material';
import React, { useState } from 'react';
import ProfileAvatar from '@mui/material/Avatar';
import { Small, Tiny } from 'app/components/Typography';
import DoctorForm from 'app/views/Doctor/DoctorForm';
import SpecialistForm from '../Specialists/SpecialistsForm';
import { deleteSpecialistAccount } from 'app/api-ws/specialists-ws';

// styled components
const ImageWrapper = styled(Box)(({ theme }) => ({
  height: 100,
  position: 'relative',
  '&::before': {
    content: '""',
    width: '100%',
    height: '100%',
    left: 0,
    top: 0,
    position: 'absolute',
    opacity: 0.6,
    backgroundColor: theme.palette.primary[100]
  }
}));

const StyledAvatar = styled(ProfileAvatar)(({ theme }) => ({
  zIndex: 1,
  width: 50,
  height: 50,
  bottom: -25,
  position: 'absolute',
  left: '50%',
  right: '50%',
  transform: 'translateX(-50%)',
  border: '2px solid',
  borderColor: theme.palette.background.paper
}));

const SpecialistUserCard = ({ fetchSpecialistDetails, user }) => {
  console.log('User data in DoctorUserCard:', user?._id);
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [doctorInfo, setDoctorInfo] = useState({
    doctorName: '',
    email: '',
    phoneNumber: '',
    refAdminId: '',
    centerAddress: '',
    aboutDoctor: ''
  });

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleAddDoctor = () => {
    console.log('Doctor Info:', doctorInfo);

    setOpenDialog(false);
  };

  const deleteDoctor = () => {
    setDeleteDialog(false);
    deleteSpecialistAccount(user?._id, user?.authToken)
      .then((r) => {
        fetchSpecialistDetails();
        setOpenDialog(false);
        setDeleteDialog(false);
      })
      .catch((e) => {
        alert('Error Deleting Specialist');
      });
  };

  return (
    <Card>
      <ImageWrapper>
        <img src={user.cover} width="100%" height="100%" alt={user.consultantName} />
        <StyledAvatar src={user.avatar} alt={user.consultantName} />
      </ImageWrapper>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          marginTop: 5
        }}
      >
        <h6>{user.consultantName?.firstName}</h6>
        <Tiny color="text.disabled" fontWeight={500}>
          {user.email}
        </Tiny>
        <Grid container spacing={2} sx={{ marginTop: 2, padding: '10px' }}>
          <Grid item xs={6} md={6}>
            <Button
              variant="contained"
              onClick={handleOpenDialog}
              sx={{ width: '100%', backgroundColor: '#66b5a3', color: 'white' }}
            >
              View Details
            </Button>
          </Grid>
          <Grid item xs={6} md={6}>
            <Button
              variant="contained"
              onClick={() => setDeleteDialog(true)}
              sx={{ width: '100%', backgroundColor: 'error.main', color: 'white' }}
            >
              Delete
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Dialog open={deleteDialog} onClose={() => setDeleteDialog(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete this doctor? This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClose={() => setDeleteDialog(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              deleteDoctor();
            }}
            color="secondary"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Grid container spacing={3} mb={2}>
        <Grid item xs={10} textAlign="center">
          <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
            <DialogTitle>{user.consultantName?.firstName}'s Details</DialogTitle>
            <DialogContent>
              <SpecialistForm
                fetchSpecialistDetails={fetchSpecialistDetails}
                specialist={user}
                handleCloseDialog={handleCloseDialog}
              />
            </DialogContent>
          </Dialog>
        </Grid>
      </Grid>
    </Card>
  );
};

export default SpecialistUserCard;
